import React, { useContext } from "react";
import { RicosViewerContext } from "./../../ricos-context";
import { ROOT } from "../dataHooks";
import styles from "../statics/styles/video-viewer-scss";
import { VIDEO_TYPE } from "../types";
import { VideoViewer } from "./video-viewer";
const Video = ({ node, nodeIndex, NodeViewContainer }) => {
  const { seoMode, config } = useContext(RicosViewerContext);
  const { videoData } = node;
  return /* @__PURE__ */ React.createElement(NodeViewContainer, { node, nodeIndex, key: node.id }, /* @__PURE__ */ React.createElement("div", { className: styles.video_container, "data-hook": ROOT }, !!videoData && /* @__PURE__ */ React.createElement(
    VideoViewer,
    {
      config: config[VIDEO_TYPE] || {},
      componentData: videoData,
      nodeId: node.id,
      seoMode: !!seoMode,
      isLight: true
    }
  )));
};
var video_default = Video;
export {
  video_default as default
};
//# sourceMappingURL=video.js.map

import "@wix/ricos/css/plugin-video-viewer.global.css";